export enum PlotTypeEnum {
  CONTOUR = 'contour',
  SCATTER = 'scatter',
}
